import { Message } from "./Message";

export type Verbose = "Verbose";
export type Info = "Info";
export type Warning = "Warning";
export type Error = "Error";

export type MessageType = Verbose | Info | Warning | Error;

export class MessageTypes
{
  static readonly Verbose:Verbose = "Verbose";
  static readonly Info:Info = "Info";
  static readonly Warning:Warning = "Warning";
  static readonly Error:Error = "Error";

  static getLevel( type:MessageType ):number
  {
    switch ( type )
    {
      case MessageTypes.Verbose: return 0;
      case MessageTypes.Info: return 1;
      case MessageTypes.Warning: return 2;
      case MessageTypes.Error: return 3;
    }

    return -1;
  }

} 